import { z } from 'zod';

export const GeminiKeySchema = z.object({
  geminiApiKey: z.string().min(1, 'API key cannot be empty').nullable(),
});

export type IGeminiKeyDto = z.infer<typeof GeminiKeySchema>;
